import{post } from '@/utils/request';
import{filerequestAnasysurl,erpserver,AddressLibrary} from '@/utils/baseUrl';
import {oaserver} from '@/utils/baseUrl';
import{erpplatserver} from '@/utils/baseUrl';

// 获取申购部门
export async function getGroupList(params) {
    return post(erpserver+'/currency/getGroupList', params, true);
}
//上传图片
export async function upload(params) {
    return post(erpplatserver+'/system/uploadFile',params,false);
}


//审核大包协议
export async function auditAgreement(params) {
    return post(erpserver+'/freight/auditAgreement',params,true)
}

//index
export async function getAgreementList(params) {
    return post(erpserver+'/freight/getAgreementList',params,true)
}
//删除
export  async  function deleteAgreement(params) {
    return  post(erpserver+'/freight/deleteAgreement',params,true)
}

//startplace
//提交审批
export async function flowSub(params) {
    return post(oaserver+'/flow/flowSub', params, true);
}

//获取币种/付款类型/承兑期限/承兑银行列表
export async function getDictList(params) {
    return post(oaserver+'/oacurrency/getDictList', params, true);
}

//查询运输公司接口
export async function searchSportCompany(params) {
    return post(oaserver+"/tran/getyscompany", params, true)
};
// 获取公司
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true);
}

export async function getRegionList(params) {
    return post(erpserver+'/freight/getRegionList',params,true)
}

export async function addDbAgreement(params) {
    return post(erpserver+'/freight/addDbAgreement',params,true)
}

export async function getAgreementDetail(params) {
    return post(erpserver+'/freight/getAgreementDetail',params,true)
}

//changeplace
//地址库
export  async  function getAddress(params) {
    return  post(AddressLibrary+'/system/getAddress',params,true)
}
export  async  function getCityList(params) {
    return  post(erpserver+'/freight/getCityList',params,true)
}
export  async  function getAddressTree(params) {
    return  post(erpserver+'/freight/getAddressTree',params,true)
}
export async function editFreightInfo(params) {
    return post(erpserver+'/freight/editFreightInfo',params,true)
}
export async function voidFreightInfo(params) {
    return post(erpserver+'/freight/voidFreightInfo',params,true)
}
export async function getFreightDetail(params) {
    return post(erpserver+'/freight/getFreightDetail',params,true)
}
//仓库 warehouse
export  async  function getWarehouseList(params) {
    return  post(erpserver+'/freight/getWarehouseList',params,true)
}
export  async  function getDbWarehouseList(params) {
    return  post(erpserver+'/freight/getDbWarehouseList',params,true)
}
export  async  function saveDbWarehouse(params) {
    return  post(erpserver+'/freight/saveDbWarehouse',params,true)
}
export  async  function delDbWarehouse(params) {
    return  post(erpserver+'/freight/delDbWarehouse',params,true)
}
//MbEdit
export async function editDbTemplate(params) {
    return post(erpserver+'/freight/editDbTemplate',params,true)
}
export async function getDbTemplateList(params) {
    return post(erpserver+'/freight/getDbTemplateList',params,true)
}